import React from 'react';
import {connect} from 'react-redux';
import * as Actions from '../../../store/actions';
import {getLighterShade} from '../colorUtils';
import {InfoIcon} from '../InfoIcon';
import {info_Green} from 'assets/images/images';

const BusinessID = ({widgets: {singleApp}}) => {
  const baseColor = singleApp?.color || singleApp?.color_code || '#3f7cdb';

  const lighterShade = getLighterShade(baseColor, 90);

  const buttonStyle = {
    backgroundColor: baseColor,
  };

  const textColor = {
    color: baseColor,
  };

  const lighterBackgroundStyle = {
    backgroundColor: lighterShade,
  };

  return (
    <>
      <div className="mt-9 px-6 overflow-y-auto max-w-sm w-full">
        {/* <div
          className="mx-auto w-fit px-2 pt-2 rounded-[10px] mb-3 text-center"
          style={lighterBackgroundStyle}
        >
          <span
            className="text-sm font-medium inline-flex items-center  "
            style={textColor}
          >
            <InfoIcon backgroundColor={baseColor} />
            To continue this on your smartphone.
            <span className="font-semibold ml-[2px]">Click here</span>
          </span>
        </div> */}

        <p className="text-center text-base font-medium text-[#1B2A4E] mb-3">
          Capture the front of your ID
        </p>

        <div className="h-[289px] relative bg-black rounded-lg border-[4px] p-3 mx-auto border-[#96a9c3] max-w-[450px] w-full">
          <div className="border-[2px] border-dashed border-[#198b7b] rounded-lg h-full flex items-center justify-center"></div>
        </div>

        <header className="flex flex-col items-center mt-4">
          <div className="flex items-center gap-2 p-2 bg-[#E2F5F6] rounded-full">
            <img src={info_Green} alt="" width={20} height={20} className="" />
            <p className="text-[10px] text-center rounded-lg text-[#4A878D] font-medium  ">
              Make sure your document is properly places, and hold it still for
              a few seconds{' '}
            </p>
          </div>
        </header>
      </div>

      <div className="flex flex-col mt-4 px-6 justify-center items-center w-full max-w-sm gap-2">
        <button
          // style={buttonStyle}
          className="text-small !text-white font-medium h-12 rounded-lg w-full !bg-brandBlue"
          disabled
        >
          Upload
        </button>
        <button
          className="text-small !text-black rounded-lg font-medium h-12 bg-[#F9F9F9] w-full border border-[#333442]"
          disabled
        >
          <span>Capture Instead</span>
        </button>
      </div>
    </>
  );
};

export default connect(state => state, Actions)(BusinessID);
